import { Component, h } from 'preact';

interface InquiryGridSearchInputProps {
  searchInput?: string;
  resultCount?: number;
  onInput?: (evt: Event) => void;
  onSubmit?: (input: string) => void;
}

export class InquiryGridSearchInput extends Component<InquiryGridSearchInputProps> {
  onSubmit(event: Event) {
    event.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(this.props.searchInput);
    }
  }

  render(props: InquiryGridSearchInputProps) {
    return (
      <form className="hi-inqsearchin" onSubmit={ e => this.onSubmit(e) }>
        <div className="hi-inqsearchin__icon">
          <i className="fas fa-search" />
        </div>
        
        <input
          className="hi-inqsearchin__input"
          placeholder="Search inquiry ID, names..."
          value={ props.searchInput }
          onInput={ props.onInput } />
        {
          props.resultCount ? 
            <span className="hi-inqsearchin__result-count">
              { `— ${props.resultCount} results found` }
            </span> : null
        }
      </form>
    );
  }
}
